
<template>
  <v-container fluid>
    <v-row class="px-8 pt-8 pb-4" v-if="false">
      <span class="text-h4 font-weight-bold">Olá</span>
    </v-row>
    

    <v-row>
      <v-col cols="12" md="6">
        <my-tasks-card></my-tasks-card>
      </v-col>
      <v-col cols="12" md="6">
        <calendar-card></calendar-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <projects-doing-card></projects-doing-card>
      </v-col>
    </v-row>


    <v-row v-if="false">
      <v-col>
        <base-card>
          <template slot="title">
            Projetos em andamento {{ $tc('banana', 1, {n: 123}) }} {{ $tc('apple', 3) }} {{ $t('projects.doing')}}
          </template>
          <template v-slot:content>
            <base-info-card-marker>
              <template slot="icon">
                <span class="mx-2 black--text">Nome do projeto</span>
              </template>
              <template slot="text">
                <v-row class="px-3 black--text" align='center'>
                  <v-col cols="6" class="pa-0">
                    <b class="ml-4">Fase atual: </b>
                    <span>FASE</span>
                  </v-col>
                  <v-col class="pa-0">
                    <v-row class="px-3" align='center'>
                      Status 
                      <v-tooltip top>
                        <template v-slot:activator="{on}">
                          <v-avatar v-on="on" size="20" color="primary" class="ml-1">
                            <v-icon x-small>mdi-circle</v-icon>
                          </v-avatar>
                        </template>
                        status
                      </v-tooltip>
                    </v-row>
                  </v-col>
                  <v-col class="pa-0">
                    <v-tooltip top>
                      <template v-slot:activator="{on}">
                        <v-icon v-on="on">mdi-account-circle</v-icon>
                      </template>
                      Usuário
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{on}">
                        <v-icon v-on="on">mdi-account-circle</v-icon>
                      </template>
                      Usuário
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{on}">
                        <v-icon v-on="on">mdi-account-circle</v-icon>
                      </template>
                      Usuário
                    </v-tooltip>
                  </v-col>
                </v-row>
              </template>
              <template slot="last">
                <span class="black--text">
                  Conclusão: <b>12/12/1212</b>
                </span>
              </template>
            </base-info-card-marker>
            <base-info-card></base-info-card>
            <base-info-card></base-info-card>
          </template>
          <template slot="actions">
            <v-btn text small color="blue-grey">ver todosss</v-btn>
          </template>
        </base-card>
      </v-col>
    </v-row>
    <v-row v-if="false">
      <v-col>
        <base-info-card></base-info-card>
        <base-info-card-marker></base-info-card-marker>
        <base-info-card-dot-marker></base-info-card-dot-marker>
        
      </v-col>

      <v-col>
        <base-card>
          <template slot="title">
            Projetos
          </template>
          <template v-slot:btn-slot>
            <f-btn show_more></f-btn>
          </template>
          <template v-slot:content>
            <div style="height:150px">
              {{ $t('test') }}
              <v-text-field
            name="name"
            label="label"
            id="id"
            disabled
            outlined
            value="asdfasdf"
          ></v-text-field>
        <base-info-card-dot-marker @click="() => {alert('clicoouu')}"></base-info-card-dot-marker>

            </div>
          </template>
        </base-card>
      </v-col>
    </v-row>

    <v-row class="px-8 pt-6 pb-4">
    </v-row>

    <v-row>
      <v-col>
        
      </v-col>

      <v-col>
        
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import CalendarCard from './cards/CalendarCard.vue'
import MyTasksCard from './cards/MyTasksCard.vue'
import ProjectsDoingCard from './cards/ProjectsDoingCard.vue'

export default {
  components: { ProjectsDoingCard, MyTasksCard, CalendarCard },
  name: 'BaseHome',
  data() {
    return {
      key: null,
      active: [],
      open: [],
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>